/** DEPRECATED - do not use in new code **/
const getChildrenExtraCharge = (unitTypeOccupancy, ratePlan, childrenAges) => {
  if (!childrenAges || !Array.isArray(childrenAges) || childrenAges.length === 0) {
    return 0
  }

  if (!unitTypeOccupancy.childrenAllowed || unitTypeOccupancy.childrenFreeOfCharge) {
    return 0
  }

  let sum = 0
  childrenAges.map(age => {
    if (age < unitTypeOccupancy.childrenAge) {
      return
    }
    sum += unitTypeOccupancy.childrenExtraCharge
  })

  return sum * ratePlan.nights
}

export default getChildrenExtraCharge
